<template>
  <v-container fluid>
    <v-dialog v-model="pracDialogByCol" fullscreen>
      <v-toolbar dark color="light-blue darken-1">
        <v-toolbar-title>Practical Wanting List By College</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark flat @click="closeDialogueByCollege()">Close</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card style="background-color: white;">
        <!-- <practicalWantingListByCollege
          :pracDialogByCol.sync="pracDialogByCol"
        /> -->
        <!-- <practicalWantingListByCollege :dialogStatus.sync="admitCardDialogStatus" :current="current"></admitCardCountByCollege> -->
      </v-card>
    </v-dialog>

    <v-layout row wrap align-center>
      <!-- {{getLoggedInExam}} -->
      <v-flex xs9>
        <v-select
          class="mx-3"
          disabled
          v-model="searchParam.exam_code"
          :items="getExamList"
          :item-text="(item) => item.code + ' - ' + item.title"
          item-value="code"
          label="Exam"
          prepend-icon="store_mall_directory"
        ></v-select>
      </v-flex>
      <!-- {{getLoggedInYear}} -->
      <v-flex xs3>
        <v-select
          class="mx-3"
          disabled
          v-model="searchParam.year"
          :items="getYearList"
          :item-text="(item) => '' + item.year + ''"
          item-value="year"
          label="Year"
          prepend-icon="calendar_today"
        ></v-select>
      </v-flex>
    </v-layout>

    <v-divider class="my-3"></v-divider>
    <!-- :disabled="ifCenterUser !== 'false'" -->
    <v-layout row wrap align-center>
      <v-flex>
        <v-layout row wrap align-center class="py-3" style="padding: 40px;">
          <v-select
            style="margin: 10px;"
            outline
            name="degree_group_code"
            label="Degree Group"
            v-model="searchParam.degree_group_code"
            :items="getAllDegreeGroup"
            :item-text="
              (item) => item.degree_group_code + '-' + item.degree_group_name
            "
            item-value="degree_group_code"
            v-validate="'required'"
            data-vv-name="degree_group_code"
            prepend-icon="edit"
            @change="getSubjectData"
            clearable
          ></v-select>
          <v-select
            outline
            style="margin: 10px;"
            v-if="searchParam.degree_group_code"
            name="subject_code"
            label="Subject"
            v-model="searchParam.subject_code"
            :items="getSubject"
            :item-text="(item) => item.subject_code + '-' + item.subject_name"
            item-value="subject_code"
            v-validate="'required'"
            data-vv-name="subject_code"
            required
            prepend-icon="edit"
            clearable
          ></v-select>
          <v-text-field
            outline
            style="margin: 10px;"
            class="ma-2"
            name="paper_code"
            label="Paper Code"
            v-model="searchParam.paper_code"
            prepend-icon="edit"
            clearable
          ></v-text-field>

          <v-text-field
            outline
            style="margin: 10px;"
            class="ma-2"
            name="college_code"
            label="College Code"
            v-model="searchParam.college_code"
            prepend-icon="edit"
            clearable
          ></v-text-field>
        </v-layout>

        <v-flex style="text-align: center;">
          <v-layout justify-center row fill-height align-center>
            <v-btn outline round large @click="searchPracticalWantList">
              <v-icon left dark>search</v-icon>Search
            </v-btn>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>

    <v-divider class="my-3"></v-divider>

    <v-container fluid>
      <v-card color="white">
        <v-layout row>
          <v-card flat>
            <v-badge left overlap>
              <template v-slot:badge>
                <v-btn
                  round
                  color="primary"
                  fab
                  small
                  style="margin-top: -1.5em;"
                  class="elevation-0"
                  v-if="pagination.totalItems"
                  >{{ pagination.totalItems }}</v-btn
                >
              </template>
              <v-card-text class="title">Practical Wanting List</v-card-text>
            </v-badge>
          </v-card>
          <v-divider class="my-2" vertical></v-divider>
        </v-layout>
      </v-card>
      <!-- {{ getPracticalWantListByCenter }} -->
      <v-data-table
        class="elevation-1"
        :headers="headers"
        :items="getPracticalWantListByCenter"
        :loading="loading"
        :pagination.sync="pagination"
        :total-items="pagination.totalItems"
        :rows-per-page-items="pagination.rowsPerPageItems"
      >
        <template v-slot:items="props">
          <!-- <td class="text-xs">{{ sl_count + props.index }}</td> -->
          <td class="text-xs">{{ props.item.rn }}</td>
           <td class="text-xs">
            <!-- <v-btn @click="openDialogueByCollege(props.item)">
              <span>
                {{ props.item.college_code }} -
                {{ props.item.college_name }}
              </span>
            </v-btn> -->
          
                [{{ props.item.college_code }}] -
                {{ props.item.college_name }}
             
          </td>
          <td class="text-xs">{{ props.item.subject_code }} - {{ props.item.subject_name }}</td>
          <td class="text-xs">{{ props.item.paper_code }} - {{ props.item.paper_name }}</td>
         
          <td class="text-xs">{{ props.item.total_wanting }}</td>
        </template>
      </v-data-table>
    </v-container>
    <!-- <pre>{{searchParam}} </pre> -->
  </v-container>
</template>

<script>
import common_login_getters from "@/mixin/common_login_getters";
import commonGet from "@/mixin/common_getters_mixin";
import commonExamYear from "@/mixin/exam_year_watch_mixin";
// import practicalWantingListByCollege from "@/components/practicalVivaExam/practicalWantingList/practicalWantingListByCollege.vue";
// import studentDetail from "@/components/examinee/practicalWantingListByCollege.vue";
export default {
  mixins: [commonGet, commonExamYear, common_login_getters],
  // components: {
  //   practicalWantingListByCollege,
  // },
  data() {
    return {
      pracDialogByCol: false,

      pagination: {
        rowsPerPage: 100,
        rowsPerPageItems: [100, 250, { text: "All", value: -1 }],
      },

      loading: false,
      sl_count: 0,

      searchParam: {
        full: true,
        admitcard: false,
        final: true,
        paper_type: 2,
      },

      headers: [
        { text: "SL", value: "sl" },
        // { text: "Exam", value: "exam_name" },
        // { text: "Year", value: "year" },
        // { text: "Center", value: "college_name" },
        { text: "College Code & Name", value: "college_code" },
        { text: "Subject Code & Name", value: "total_mark_count" },
        { text: "Paper Code & Name", value: "paper_code" },
        { text: "Total wanting Numbers", value: "total_wanting"},
      ],
    };
  },
  created() {
    this.addPaper();
    // this.$store.dispatch("fetchSessionData");
    // this.getPracticalCenter();
    this.searchParam.exam_initiate_id = this.getExamInitiateId;
    // this.searchParam.center_code = this.getAuthUser.center.center_code;
    if (this.ifCenterUser) {
      //this.searchParam.center_code = [
      //this.getAuthUser.center.practical_center_code,
      //];
    }
    // if (!this.$store.getters.getCenterItems.length) {
    //   this.$store.dispatch("fetchCenterData");
    // }

    // if (!this.$store.getters.getCenterListByPractical.length) {
    let param = {};
    param.exam_initiate_id = this.getExamInitiateId;
    param.exam_code = this.getLoggedInExam.code;
    param.year = this.getLoggedInYear.year;
    //param.center_code = this.getAuthUser.center.practical_center_code;
    //this.$store.dispatch("fetchPracticalWiseCenterData", param);
    // }
  },
  computed: {
    //all data
    getPracticalWantListByCenter() {
      return this.$store.getters.getPracticalWantListByCenter;
    },
    // getAllDegreeGroup() {
    //   return this.$store.getters.getStudentFFpaperData;
    // },
    getAllDegreeGroup() {
      return this.$store.getters.getAllDegreeGroup;
    },
    getSubject() {
      return this.$store.getters.getAllSubject;
    },
    getAllPaperType(state) {
      return this.$store.getters.getAllPaperType;
    },
    getLoggedInDegree() {
      return this.$store.getters.getLoggedInDegree;
    },
    // center
    // getPracticalCenterList() {
    //   return this.$store.getters.getPracticalCenterList;
    // },
  },
  methods: {
    // addPaper(details) {
    //   this.addpaperDialog = true;
    //   let payloadData = {
    //     exam_code: this.getLoggedInExam.code,
    //   };
    //   console.log(payloadData);
    //   this.$store.dispatch("addNewPaperData", payloadData).then((rsp) => {

    //   });
    // },
    addPaper() {
      this.$store.dispatch("fetchAllDegreeGroupData", {
        params: { degree_code: this.getLoggedInDegree.code },
      });
    },
    getSubjectData(degree_group_code) {
      this.$store.dispatch("fetchAllSubjectData", {
        params: { degree_group_code: degree_group_code },
      });
    },

    getPracticalCenter() {
      let param = {};
      param.exam_initiate_id = this.getExamInitiateId;
      param.exam_code = this.getLoggedInExam.code;
      param.year = this.getLoggedInYear.year;
      this.$store.dispatch("fetchPracticalWiseCenterData", param);
    },
    openDialogueByCollege(currentItem) {
      //this.$store.commit("UNSET_PRACTICAL_WANT_DATA_BY_COLLEGE");
      this.$store.commit(
        "SET_PRACTICAL_WANT_DATA_BY_CENTER_CURRENT",
        currentItem
      );
      this.pracDialogByCol = true;
    },
    closeDialogueByCollege() {
      this.pracDialogByCol = false;
    },

    setLimit() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      this.searchParam.page = page;
      this.searchParam.limit = rowsPerPage;
      this.searchParam.sortBy = sortBy;
      this.searchParam.search = this.search;
    },

    searchPracticalWantList() {
      this.loading = true;
      this.setLimit();
      let payload = {
        exam_code: this.searchParam.exam_code,
        exam_year: this.searchParam.year,
        paper_type: 2,
        limit: this.searchParam.limit,
        subject_code: this.searchParam.subject_code,
        paper_code: this.searchParam.paper_code,
        college_code: this.searchParam.college_code,
      };
      this.$store
        .dispatch("searchPracticalWantDataByCenter", payload)
        .then((data) => {
          this.loading = false;
          this.sl_count = data.from;
          this.pagination.totalItems = data.total;
        });
    },

    // removeCenter(item) {
    //   const index = this.searchParam.center_code.indexOf(item.center_code);
    //   if (index >= 0) this.searchParam.center_code.splice(index, 1);
    // },
  },
  watch: {
    getExamInitiateId(val) {
      this.searchParam.exam_initiate_id = val;
    },
    pagination(val) {
      this.searchPracticalWantList();
    },
  },
};
</script>
<style scoped>
.mycustomExpansionPanel .v-expansion-panel__header {
  border: 1px solid rgb(255, 255, 255) !important;
}

.Male {
  background-color: #386c8e;
  color: white;
}
.Female {
  background-color: #ad2da3;
  color: white;
}
</style>
